import { tw } from '@/utils/tw';
import BaseStrossleTheme from 'base/components/Strossle/theme';

const Strossle = tw.theme({
  extend: BaseStrossleTheme,
  base: `px-0`,
});

export default Strossle;
